import { EFinancingCompany, EFinancingProgram } from '@if/core/types'
import type { InferSubmit } from '@if/core/yup'
import * as yup from '@if/core/yup'
import { ELoanStatus } from '@src/types/constants'

const SEARCH_TERM_MAX_LENGTH = 100

export const loanDashBoardFiltersSchema = yup.object({
  searchTerm: yup
    .string()
    .default('')
    .transform((value: string) => value.slice(0, SEARCH_TERM_MAX_LENGTH)),
})

export type LoanDashBoardFiltersSchemaType = InferSubmit<typeof loanDashBoardFiltersSchema>

export interface LoanDashboardEntry {
  loanId: number
  loanAmount: number
  loanBalance: number
  borrowerFullName: string
  financingCompanyId: EFinancingCompany
  financingProgramId: EFinancingProgram
  contractNumber: string
  creditReferenceNumber: number | null
  loanStatusId: ELoanStatus
  createdOn: string
  timestamp: number
}
